import type { ReactNode } from "react";
import { AdminAuthLayout } from "./admin-auth-layout";
import { CustomerAuthLayout } from "./customer-auth-layout";
import {
  resolvePageLayout,
  type NextPageWithLayout,
} from "./page-layout";

interface AppLayoutProps {
  Component: NextPageWithLayout;
  children: ReactNode;
}

export const AppLayout = ({ Component, children }: AppLayoutProps) => {
  const layout = resolvePageLayout(Component);

  if (layout.type === "admin") {
    return <AdminAuthLayout>{children}</AdminAuthLayout>;
  }

  if (layout.type === "customer") {
    return (
      <CustomerAuthLayout {...(layout.props || {})}>
        {children}
      </CustomerAuthLayout>
    );
  }

  return <>{children}</>;
};
